import { useIntercom } from 'react-use-intercom';
import app from 'srcJs/App';
import { IntercomContextValues } from 'react-use-intercom/src/types';

const useIntercomShow = (): IntercomContextValues['show'] => {
  if (!app.getExternalApp().isEnableIntercom()) {
    return () => undefined;
  }

  const { show } = useIntercom();
  return show;
};

export { useIntercomShow };
